__turbopack_context__.v({
  "container": "ChangeEmailAddressSlidingModal-module__O-vlZq__container",
  "errorIntro": "ChangeEmailAddressSlidingModal-module__O-vlZq__errorIntro",
  "formContainer": "ChangeEmailAddressSlidingModal-module__O-vlZq__formContainer",
  "heading": "ChangeEmailAddressSlidingModal-module__O-vlZq__heading",
});
